import i18next from 'i18next';
export const SUBSCRIPTION_TERM = {
  Monthly: 'Monthly',
  SemiAnnual: 'SemiAnnual',
  Annual: 'Annual'
};
export const SUBSCRIPTION_TERMS = {
  [SUBSCRIPTION_TERM.Monthly]: {
    lengthInMonths: 1,
    sortRank: 0,
    termLengthKey: 'subscriptions.term_length_monthly',
    termLabelKey: 'subscriptions.term_monthly',
    renewalWordingKey: 'subscriptions.term_renews_monthly'
  },
  [SUBSCRIPTION_TERM.Annual]: {
    lengthInMonths: 12,
    sortRank: 1,
    termLengthKey: 'subscriptions.term_length_annual',
    termLabelKey: 'subscriptions.term_annual',
    renewalWordingKey: 'subscriptions.term_renews_annual'
  },
  [SUBSCRIPTION_TERM.SemiAnnual]: {
    lengthInMonths: 6,
    sortRank: 2,
    termLengthKey: 'subscriptions.term_length_half_yearly',
    termLabelKey: 'subscriptions.term_half_yearly',
    renewalWordingKey: 'subscriptions.term_renews_half_yearly'
  }
};
const UNRANKED = Object.keys(SUBSCRIPTION_TERMS).length;
export function getSubscriptionTermLength(term) {
  var _SUBSCRIPTION_TERMS$t;
  if (!term) return '';
  const key = (_SUBSCRIPTION_TERMS$t = SUBSCRIPTION_TERMS[term]) === null || _SUBSCRIPTION_TERMS$t === void 0 ? void 0 : _SUBSCRIPTION_TERMS$t.termLengthKey;
  return key ? i18next.t(key) : term;
}
export function getSubscriptionTermLabel(term) {
  var _SUBSCRIPTION_TERMS$t2;
  if (!term) return '';
  const key = (_SUBSCRIPTION_TERMS$t2 = SUBSCRIPTION_TERMS[term]) === null || _SUBSCRIPTION_TERMS$t2 === void 0 ? void 0 : _SUBSCRIPTION_TERMS$t2.termLabelKey;
  return key ? i18next.t(key) : term;
}
export function getSubscriptionTermRenewalWording(term) {
  var _SUBSCRIPTION_TERMS$t3;
  if (!term) return '';
  const key = (_SUBSCRIPTION_TERMS$t3 = SUBSCRIPTION_TERMS[term]) === null || _SUBSCRIPTION_TERMS$t3 === void 0 ? void 0 : _SUBSCRIPTION_TERMS$t3.renewalWordingKey;
  return key ? i18next.t(key) : '';
}
export function getSubscriptionTermLengthInMonths(term) {
  var _SUBSCRIPTION_TERMS$t4;
  return term && ((_SUBSCRIPTION_TERMS$t4 = SUBSCRIPTION_TERMS[term]) === null || _SUBSCRIPTION_TERMS$t4 === void 0 ? void 0 : _SUBSCRIPTION_TERMS$t4.lengthInMonths) || 0;
}
export function getSubscriptionTermSortRank(term) {
  return term && SUBSCRIPTION_TERMS[term] ? SUBSCRIPTION_TERMS[term].sortRank : UNRANKED;
}